import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { EmployerVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { CraService } from 'src/app/services/cra.service';
import { NgForm } from '@angular/forms';
import { filter, debounceTime } from 'rxjs/operators';


@Component({
  selector: 'app-employment-data',
  templateUrl: './employment-data.component.html',
  styleUrls: ['./employment-data.component.less']
})
export class EmploymentDataComponent implements OnInit, AfterViewInit {

  @Input() model : EmployerVerificationData;
  @Input() submitted : boolean;
  @Output() completed : EventEmitter<any> = new EventEmitter();
  @ViewChild(NgForm,{}) form : NgForm;
  constructor(public cra: CraService) { }
  
  ngAfterViewInit(): void {
    this.form.statusChanges.pipe(
      filter(()=>{ return this.form.valid && this.form.dirty; }),
      debounceTime(2000)
    ).subscribe(()=>{
      // console.debug('Employment Form', this.model);
      this.completed.emit('Employment Form Complete');
    })
  }
  
  ngOnInit() {

  }

}
